import { inject, type InjectionKey } from 'vue'
import type { ShowAddAgencyGroupModalParams } from '../modals/AgencyGroupModalAdd.vue'
import type { ShowAddAgencyModalParams } from '../modals/AgencyModalAdd.vue'
import type { ShowRemoveAgencyGroupModalParams } from '../modals/AgencyGroupModalRemove.vue'
import type { ShowChangeAgencyGroupNameModalParams } from '../modals/AgencyGroupModalChangeName.vue'
import type { ShowMoveAgencyGroupModalParams } from '../modals/AgencyGroupModalMove.vue'

export interface AgencyStructureModalsProviderContext {
  showAddAgencyGroupModal: (params: ShowAddAgencyGroupModalParams) => void
  showAddAgencyModal: (params: ShowAddAgencyModalParams) => void
  showRemoveAgencyGroupModal: (params: ShowRemoveAgencyGroupModalParams) => void
  showChangeAgencyGroupNameModal: (
    params: ShowChangeAgencyGroupNameModalParams
  ) => void
  showMoveAgencyGroupModal: (params: ShowMoveAgencyGroupModalParams) => void
}

export const agencyStructureModalsKey = Symbol(
  'gs-agency-structure-modals'
) as InjectionKey<AgencyStructureModalsProviderContext>

export function useAgencyStructureModals() {
  return inject(agencyStructureModalsKey)
}
